module.exports = __webpack_public_path__ + "517a3a485a9dae5d2e59c451cb2675db.gif";